import { StyledAlertContainer } from 'apps/shared/ui/alert/alert.styled';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import type { SemanticICONS } from 'semantic-ui-react';
import { Icon } from 'semantic-ui-react';

export interface AlertProps {
  type: 'info' | 'confirm' | 'warning';
  message: ReactNode;
}

const Alert = (props: AlertProps) => {
  const { type, message } = props;

  const iconName = useMemo((): SemanticICONS => {
    if (type === 'confirm') return 'check circle outline';
    if (type === 'info') return 'info circle';
    if (type === 'warning') return 'warning sign';
    return 'check circle outline';
  }, [type]);

  return (
    <StyledAlertContainer $type={type}>
      <Icon name={iconName} size="large" />
      <p>{message}</p>
    </StyledAlertContainer>
  );
};

export default Alert;
